import { Button, Grid, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContentAdd } from '@fs/zion-icon'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import { useCardSkeletonColumns } from '../useSingleOrDoubleColumns'
import OtherRelationshipsLoading from './OtherRelationshipsLoading'

type Props = {
  isSingleCardPage?: boolean
  totalColumns?: number
}

export default function OtherRelationshipsCardSkeleton({
  isSingleCardPage = true,
  totalColumns = 12,
}: Props): JSX.Element {
  const [t] = useTranslation()
  const columns = useCardSkeletonColumns(totalColumns)

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.other-relationships.header')}>
        <Button Icon={ContentAdd} data-testid="add-other-relationship-button" disabled>
          {t('tree-person.other-relationship.add.header')}
        </Button>
        <Separator size="nano" />
        <OtherRelationshipsLoading columns={columns} />
      </SectionCardSkeleton>
    </Grid>
  )
}
